import React, {useEffect} from "react";
import {Button, Divider, Stack, Typography} from "@mui/material";
import {dataManager} from "../../Broadtask";
import {useNavigate} from "react-router-dom";
import GridViewIcon from "@mui/icons-material/GridView";
import {Check} from "@mui/icons-material";
import {buttonStyle, sectionStack, subSectionPanel} from "../../../AppStyles";

const TaskableHistoryPane = (props) => {

    const navigate = useNavigate();

    useEffect(() => {
        dataManager.getTaskableManager().getInstance(props.taskableUID).getHistory(false, (history) => {

        });
    }, [props.taskableUID]);

    function onView()
    {
        navigate("/taskables/" + props.taskableUID + "/history");
    }

    return (
        <Stack direction="column" spacing={1} padding={1} width="100%"
               alignItems="flex-start" justifyContent="flex-start"
               sx={sectionStack}>
            <Stack direction="row" width="100%"
                   justifyContent="space-between"
                   padding={1} spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <img src="/icons/task_processor.png" width={32} height={32}/>
                    <Typography variant="h6">History</Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Button onClick={onView} sx={buttonStyle} startIcon={<GridViewIcon />}>VIEW</Button>
                </Stack>
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
            <Stack direction="column" spacing={1} width="100%" minHeight={100}
                   sx={subSectionPanel}>

            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
        </Stack>
    );
}

export default TaskableHistoryPane;
